
import { defineComponent, PropType } from 'vue';
import IconSeminar from "@/components/icons/IconSeminar.vue";
import LinkTarget from "@/components/LinkTarget.vue";
import {Tutor, Event} from "@/types";

export default defineComponent({
  name: 'SeminarHeader',
  props: {
    event: {
      type: Object as PropType<Event>,
      required: true
    },
    icon: {
      type: String,
      default: '/pic/online-seminar/kkt.svg'
    }
  },
  components: {
    IconSeminar,
    LinkTarget
  },
  methods: {
    getMainTutorName(tutors: Tutor[]): string {
      if (!tutors.length) return '';
      const mainTutor = tutors[0];
      return mainTutor.fullname;
    }
  }
});
